module.exports = __webpack_public_path__ + "static/media/serviceArrow.104b8232.svg";